module.exports = __webpack_public_path__ + "img/logo_mono.d9c1da43.svg";